import { formatPercent, formatNumber, safeDivide } from "../helpers";

export function FunnelStage({ stage, total }) {
  const ratio = safeDivide(stage.value, total);
  const rate = safeDivide(stage.value, stage.rateTotal ?? total);
  const width = stage.value === null || stage.value === undefined
    ? 0
    : Math.max(4, Math.min(100, Number(ratio || 0) * 100));

  return (
    <div className="space-y-1.5">
      <div className="flex items-center justify-between gap-3 text-sm">
        <span className="font-medium text-gray-700">{stage.label}</span>
        <span className="text-gray-600">
          <strong>{formatNumber(stage.value)}</strong>
          {stage.showRate && <span className="ml-2">({formatPercent(rate)})</span>}
        </span>
      </div>
      <div className="h-2.5 overflow-hidden rounded-full bg-gray-100">
        <div
          className={`h-full rounded-full ${stage.className}`}
          style={{ width: `${width}%` }}
        />
      </div>
    </div>
  );
}
